'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.string = undefined;

var _isnil = require('./lib/isnil.js');

var _string = require('./lib/string');

/*
 * Checks for a 'String'
 * @param string - value for check
 * @return boolean
 */
var isString = function isString(string) {
  return (0, _string._isString)(string);
};

/*
 * Validates the size of the 'string' is greater than or equal to (> =) the max
 * @param minLength
 * @param string - value for check
 * @return boolean
 */
var minLength = function minLength() {
  var min = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Number.MIN_VALUE;
  return function (string) {
    return (0, _string._isString)(string) && string.length >= min;
  };
};

/*
 * Validates the size of the 'string' is less than or equal to (<=) the min
 * @param maxLength
 * @param string - value for check
 * @return boolean
 */
var maxLength = function maxLength() {
  var max = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Number.MAX_VALUE;

  if ((0, _isnil.isNil)(max)) {
    max = Number.MAX_VALUE;
  }
  return function (string) {
    return (0, _string._isString)(string) && string.length <= max;
  };
};

/*
 * Validates that the length of the string is within the range
 * @param min
 * @param max
 * @return boolean
 */
var length = function length() {
  var min = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Number.MIN_VALUE;
  var max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.MAX_VALUE;
  return function (string) {
    return minLength(min)(string) && maxLength(max)(string);
  };
};

/*
 * Validate regular expressions
 * @doc https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
 * @param expression
 * @param lastIndex
 * @return boolean
 */
var regex = function regex(expression) {
  return function (string) {
    var reg = new RegExp(expression);
    return reg.test(string);
  };
};

/*
 * Export constant string
 */
var string = exports.string = {
  isString: isString,
  minLength: minLength,
  maxLength: maxLength,
  length: length,
  regex: regex
};